// src/redux/actions/genderActions.js

import axios from "../../API/axios";
import {
  FETCH_GENDERS_REQUEST,
  FETCH_GENDERS_SUCCESS,
  FETCH_GENDERS_FAILURE,
  SET_SELECTED_GENDER,
} from "../types";

export const fetchGenders = () => async (dispatch) => {
  dispatch({ type: FETCH_GENDERS_REQUEST });
  try {
    const response = await axios.get(`/MasterData/GetGendersDDL`);
    // console.log('nbnzxb',response);
    let genderlist = response.data.responseData.map((val)=>{
        return{value:val.gndrId,label:val.name}
    })
    dispatch({
      type: FETCH_GENDERS_SUCCESS,
      payload: genderlist,
    });
  } catch (error) {
    dispatch({ type: FETCH_GENDERS_FAILURE, payload: error.message });
  }
};

export const selectGender = (genderId) => ({  
  type: SET_SELECTED_GENDER,
  payload: genderId,
});
